import { ApiRequest, ApiResponse } from 'services/providers/dapv.types';
import { dapvApi } from 'services/providers/dapv';
import { Appointment, CreateAppointmentPayload, UpdateAppointmentPayload } from 'services/appointment/appointment.types';

const appointmentApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getAllAppointments: build.mutation<ApiResponse<Appointment[]>, ApiRequest<{ project_id: string }>>({
            query: ({ project_id }) => ({
                url: `/user/projects/${project_id}/appointments`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<Appointment[]>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createAppointment: build.mutation<ApiResponse<Appointment>, CreateAppointmentPayload>({
            query: (body: CreateAppointmentPayload) => ({
                url: `/user/projects/${body.project_id}/appointments`,
                method: 'POST',
                body
            }),
            transformResponse: (response: ApiResponse<Appointment>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateAppointment: build.mutation<ApiResponse<Appointment>, UpdateAppointmentPayload>({
            query: (body: UpdateAppointmentPayload) => ({
                url: `/app/projects/${body.project_id}/appointments/${body.id}`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: ApiResponse<Appointment>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const { useGetAllAppointmentsMutation, useCreateAppointmentMutation, useUpdateAppointmentMutation } = appointmentApi;
